module.exports = __webpack_public_path__ + "img/2.209523dd.jpg";